import Vue from 'vue';
import Router, { Route } from 'vue-router';
import {store, isAdmin, isCampaignAdmin} from './store';
import Home from './views/Main/Home.vue';
import MainLayout from './views/Main/MainLayout.vue';
import Submission from './views/Main/Submission.vue';
import {fetchAdminCampaigns} from "@/actions";
const AdminHome = () => import('@/views/Admin/AdminHome.vue');
const AdminCampaigns = () => import('@/views/Admin/AdminCampaigns.vue');
const AdminLayout = () => import('@/views/Admin/AdminLayout.vue');
const AdminSettings = () => import('@/views/Admin/AdminSettings.vue');
const UserSettings = () => import('@/views/Admin/settings/Users.vue');
const GeneralSettings = () => import('@/views/Admin/settings/General.vue');
const WebhookSettings = () => import('@/views/Admin/settings/WebhookEndpoints.vue');
const AdminCampaignAdvSettings = () => import('@/views/Admin/AdminCampaignAdvSettings.vue');
const CampaignGeneralSettings = () => import('@/views/Admin/settings/campaign/CampaignGeneral.vue');
const Print = () => import('./views/Main/Print.vue');

Vue.use(Router);

const checkAuthenticated = (to: Route, from: Route, next) => {
    if (store.isAuthenticated) {
        next();
    } else {
        window.location.href = `${process.env.VUE_APP_LOGIN_URI}?returnUrl=${window.location.href}`;
    }
};

const checkForSubmissionId = (to: Route, from: Route, next) => {
    if (store.submissionId || process.env['NODE_ENV'] === 'development') {
        next();
    } else {
        next({ name: 'home' });
    }
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: AdminLayout,
            beforeEnter: (to, from, next) => checkAuthenticated(to, from, next),
            children: [
                { path: '', name: 'admin', component: AdminHome },
                {
                    path: 'campaigns/:campaignPath?',
                    name: 'campaigns',
                    component: AdminCampaigns,
                    props: true,
                },
                {
                    beforeEnter: (to, from, next) => {
                        fetchAdminCampaigns().then(() => {
                            if (isCampaignAdmin(to.params.campaignPath) || isAdmin()) {
                                next();
                            } else {
                                console.log('redirect');
                                next('/');
                            }
                        });
                    },
                    path: 'campaigns/:campaignPath/settings',
                    name: 'campaignSettings',
                    redirect: { name: 'campaignGeneralSettings' },
                    component: AdminCampaignAdvSettings,
                    props: true,
                    children: [
                        {
                            path: 'general',
                            name: 'campaignGeneralSettings',
                            component: CampaignGeneralSettings,
                            props: true,
                        },
                    ],
                },
                {
                    beforeEnter: (to, from, next) => {
                        if (isAdmin()) {
                            next();
                        } else {
                            console.log('redirect');
                            next('/');
                        }
                    },
                    path: 'settings',
                    name: 'settings',
                    redirect: { name: 'generalSettings' },
                    component: AdminSettings,
                    children: [
                        {
                            path: 'general',
                            name: 'generalSettings',
                            component: GeneralSettings,
                        },
                        {
                            path: 'users',
                            name: 'userSettings',
                            component: UserSettings,
                        },
                        {
                            path: 'webhooks',
                            name: 'webhookSettings',
                            component: WebhookSettings
                        }
                    ],
                },
            ],
        },
        {
            path: '/:campaign/print',
            name: 'print',
            component: Print,
            props: true,
        },
        {
            path: '*',
            component: MainLayout,
        },
    ],
});
